import { render, staticRenderFns } from "./AddBinnacle.vue?vue&type=template&id=6b29c6b8&scoped=true"
import script from "./AddBinnacle.vue?vue&type=script&lang=js"
export * from "./AddBinnacle.vue?vue&type=script&lang=js"
import style0 from "./AddBinnacle.vue?vue&type=style&index=0&id=6b29c6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b29c6b8",
  null
  
)

export default component.exports